module.exports = require("jsonlint-mod");